import { CHANGE_LANGUAGE } from './constants';
import en from "../helpers/Language/en.json";
import so from "../helpers/Language/so.json";

export const currentLanguage = (currentlanguage) => {
    return {
      type: CHANGE_LANGUAGE,
      currentlanguage,
    }; 
};

export const changeLanguage = (params = 'so') => {
    return (dispatch,getState) => {
        let setstate = {};
        if(params == 'en'){
            setstate = {language : params , languagelist : en};
        }else{
            setstate = {language : params , languagelist : so};
        }
        dispatch(currentLanguage(setstate));
    }
};